export const paymentDetailsTableData = [
  {
    si_DocNum: "604",
    ap_DocNum: "952",
    invoice_Amount: "5900",
    remarks: "IT Infutech Inv 85/2024-25",
  },
  {
    si_DocNum: "604",
    ap_DocNum: "952",
    invoice_Amount: "5900",
    remarks: "IT Infutech Inv 85/2024-25",
  },
];

export const paymentStatusTableData = [
  {
    payment_No: "101",
    date: "27/08/2024",
    vendor_Name: "Computer Exchange Pvt Ltd",
    amount: "5900",
    naration: "IT Infutech Inv 85/2024-25",
    status: "Paid",
  },
  {
    payment_No: "101",
    date: "27/08/2024",
    vendor_Name: "Computer Exchange Pvt Ltd",
    amount: "5900",
    naration: "IT Infutech Inv 85/2024-25",
    status: "Paid",
  },
  {
    payment_No: "101",
    date: "27/08/2024",
    vendor_Name: "Computer Exchange Pvt Ltd",
    amount: "5900",
    naration: "IT Infutech Inv 85/2024-25",
    status: "Paid",
  },
  {
    payment_No: "101",
    date: "27/08/2024",
    vendor_Name: "Computer Exchange Pvt Ltd",
    amount: "5900",
    naration: "IT Infutech Inv 85/2024-25",
    status: "Paid",
  },
];

export const invDetailsTableData = [
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "5264",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "3598",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "100",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "250",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "4850",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "4540",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "4540",
    dept_status: "Approved",
    fin_status: "Pending",
  },
  {
    inv_Doc_No: "101",
    vendor_Ref_No: "CFS/320/2024-25",
    doc_Date: "27/08/2024",
    po_DocEntry: "12728",
    vendor_Name: "Computer Exchange Pvt Ltd",
    payment: "450",
    dept_status: "Approved",
    fin_status: "Pending",
  },
];

export const poDetailsTableData = [
  {
    line_No: "0",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "1",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "2",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "3",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "4",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "5",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "6",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "7",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
  {
    line_No: "8",
    item_Name: "Transportation Charges",
    qty: "1",
    discount_Percent: "0%",
    unit_Rate: "3400",
    line_Total: "3400",
    tax_Code: "NCGSG5",
    tax_Percent: "5%",
    tax_Amount: 170,
    gross_Total: 3570,
    uom: "Manual",
    status: "Pending",
  },
];

export const poTableData = [
  {
    po_DocEntry: "12728",
    Doc_No: "101",
    date: "27/08/2024",
    vendor_Ref_No: "CFS/320/2024-25",
    vendor_Name: "Computer Exchange Pvt Ltd",
    ship_To:
      "1757/A, 34th Cross Banashankari 2nd Stage, Bangalore-560070 KT - IN",
    bill_To:
      "No.1442, 21st cross, 5th main7th sector HSR layout Bengaluru-560102 KT - IN",
    tax_Amount: 170,
    doc_Total: 3910,
    remarks:
      "	Towards Cab chgs from 15th to 17th may 24 for Balasubramanian & Surendra Gupta",
  },
  {
    po_DocEntry: "12728",
    Doc_No: "101",
    date: "27/08/2024",
    vendor_Ref_No: "CFS/320/2024-25",
    vendor_Name: "Computer Exchange Pvt Ltd",
    ship_To:
      "1757/A, 34th Cross Banashankari 2nd Stage, Bangalore-560070 KT - IN",
    bill_To:
      "No.1442, 21st cross, 5th main7th sector HSR layout Bengaluru-560102 KT - IN",
    tax_Amount: 170,
    doc_Total: 3910,
    remarks:
      "	Towards Cab chgs from 15th to 17th may 24 for Balasubramanian & Surendra Gupta",
  },
  {
    po_DocEntry: "12728",
    Doc_No: "101",
    date: "27/08/2024",
    vendor_Ref_No: "CFS/320/2024-25",
    vendor_Name: "Computer Exchange Pvt Ltd",
    ship_To:
      "1757/A, 34th Cross Banashankari 2nd Stage, Bangalore-560070 KT - IN",
    bill_To:
      "No.1442, 21st cross, 5th main7th sector HSR layout Bengaluru-560102 KT - IN",
    tax_Amount: 170,
    doc_Total: 3910,
    remarks:
      "	Towards Cab chgs from 15th to 17th may 24 for Balasubramanian & Surendra Gupta",
  },
  {
    po_DocEntry: "12728",
    Doc_No: "101",
    date: "27/08/2024",
    vendor_Ref_No: "CFS/320/2024-25",
    vendor_Name: "Computer Exchange Pvt Ltd",
    ship_To:
      "1757/A, 34th Cross Banashankari 2nd Stage, Bangalore-560070 KT - IN",
    bill_To:
      "No.1442, 21st cross, 5th main7th sector HSR layout Bengaluru-560102 KT - IN",
    tax_Amount: 170,
    doc_Total: 3910,
    remarks:
      "	Towards Cab chgs from 15th to 17th may 24 for Balasubramanian & Surendra Gupta",
  },
  {
    po_DocEntry: "12728",
    Doc_No: "101",
    date: "27/08/2024",
    vendor_Ref_No: "CFS/320/2024-25",
    vendor_Name: "Computer Exchange Pvt Ltd",
    ship_To:
      "1757/A, 34th Cross Banashankari 2nd Stage, Bangalore-560070 KT - IN",
    bill_To:
      "No.1442, 21st cross, 5th main7th sector HSR layout Bengaluru-560102 KT - IN",
    tax_Amount: 170,
    doc_Total: 3910,
    remarks:
      "	Towards Cab chgs from 15th to 17th may 24 for Balasubramanian & Surendra Gupta",
  },
];
export const vendorTableData = [
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V0468301",
    r1: 923,
    r2: 914,
    r3: 911,
    contactPerson: "Vinay Kumar",
    mobile: "9945134090	",
    email: "blr-bo@computerexchangeindia.com",
    Status: "Active",
  },
];

export const branchTableData = [
  {
    name: "Karnataka",
    code: "01",
    poc: {
      name: "Dimpu",
      mobile: "08544545454",
      email: "dimpu@VhdBranch.com",
    },
    country: "India",
    zone: "South",
    state: "Karnataka",
    city: "Mysore",
    shortLocation:
      "#809, First Floor, Contour Road, Gokulam 3rd Stage 570002 A29,",
    location:
      "#809, First Floor, Contour Road,Gokulam 3rd Stage 570002 A29, FIEE Complex, Phase-II,Okhla Industrial Area, South Delhi, 110020 A-29, Phase-II, Okhla Industrial Area, South Delhi, FIEE Complex, 110020",
    status: "active",
  },
  {
    name: "Karnataka",
    code: "01",
    poc: {
      name: "Dimpu",
      mobile: "08544545454",
      email: "dimpu@VhdBranch.com",
    },
    country: "India",
    zone: "South",
    state: "Karnataka",
    city: "Mysore",
    shortLocation:
      "#809, First Floor, Contour Road, Gokulam 3rd Stage 570002 A29,",
    location:
      "#809, First Floor, Contour Road,Gokulam 3rd Stage 570002 A29, FIEE Complex, Phase-II,Okhla Industrial Area, South Delhi, 110020 A-29, Phase-II, Okhla Industrial Area, South Delhi, FIEE Complex, 110020",
    status: "inactive",
  },
];

export const dashboardTableData = [
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
  {
    name: "Computer Exchange Pvt Ltd",
    code: "V04683",
    po: 23,
    invoice: 14,
    payment: 11,
  },
];
